import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RangeSlider from 'react-bootstrap-range-slider';

import { editContent } from '../../modules/editor';

import FieldSection from './FieldSection';

import useDebounce from '../../hooks/useDebounce';
import { validHtml } from '../../util/html';
import useAlert from '../../hooks/useAlert';

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentHtmlcode({ selectedContentId, currentContent }: Props) {
	const Alert = useAlert();
  const dispatch = useDispatch();

	const [dbHeight, height, setHeight] = useDebounce<number>(
		Number(currentContent?.content?.style[0]?.box?.height?.replace('px', '')),
		100
	);

	const onChange = (e:any) => {
		const { value } = e.target;
    setHeight(value);
	}

	useEffect(() => {
		setHeight(Number(currentContent?.content?.style[0]?.box?.height?.replace('px', '')));
	}, [currentContent]);
	
	useEffect(() => {
		dispatch(editContent({ target: `${selectedContentId}/style/0/box/height`, data: `${height}px` }));
	}, [dbHeight]);

	return (
		<div className="editor-sidebar-selected-content-setting">
			<h3 className="field-section-title">공백</h3>
			<div className="slider-field">
				<span>10px</span>
				<span>100px</span>
			</div>
			<FieldSection
				labelName=""
				layout="vertical"
			>	
				<RangeSlider
					value={height}
					onChange={(e:any) => {onChange(e)}}
					min={10}
					max={100}
					step={5}
				/>
			</FieldSection>
		</div>
	);
}

export default SelectedContentHtmlcode;